<script lang="ts">
  import { TOOLS } from '$lib/core/interaction';
  import type { EditorState } from '../editor-state.svelte';

  const { editor }: { editor: EditorState } = $props();

  /** The mode after the current one, which a click on the mode label switches to. */
  const nextMode = $derived.by(() => {
    const modes = editor.toolModes;
    const index = modes.findIndex((mode) => mode.id === editor.toolMode);
    return modes[(index + 1) % modes.length] ?? null;
  });
  const currentMode = $derived(editor.toolModes.find((mode) => mode.id === editor.toolMode));
</script>

<div class="palette" role="toolbar" aria-label="Tools">
  {#each TOOLS as tool (tool.id)}
    <button
      type="button"
      class:active={editor.activeToolId === tool.id}
      aria-pressed={editor.activeToolId === tool.id}
      title="{tool.label} ({tool.shortcut})"
      onclick={() => editor.setTool(tool.id)}
    >
      <span>{tool.label}</span>
      <kbd>{tool.shortcut}</kbd>
    </button>
    {#if editor.activeToolId === tool.id && currentMode && nextMode}
      <button
        type="button"
        class="mode"
        title="Switch to {nextMode.label} (Tab)"
        onclick={() => editor.setToolMode(nextMode.id)}
      >
        <span>{currentMode.label}</span>
        <kbd>Tab</kbd>
      </button>
    {/if}
  {/each}
</div>

<style>
  .palette {
    display: flex;
    gap: var(--space-1);
  }

  button {
    display: inline-flex;
    align-items: center;
    gap: var(--space-2);
    padding: var(--space-2) var(--space-3);
    border: 1px solid var(--color-border);
    border-radius: var(--radius);
    background: var(--color-surface);
    color: var(--color-text);
    font: inherit;
    font-size: 0.8125rem;
    cursor: pointer;
  }

  button:hover {
    border-color: var(--color-accent);
  }

  button.active {
    background: var(--color-accent);
    border-color: var(--color-accent);
    color: #fff;
  }

  button.mode {
    border-style: dashed;
  }

  kbd {
    font-size: 0.6875rem;
    opacity: 0.7;
  }
</style>
